import { number, RequestKind, string } from '@sb/library/base';
import { GeographicalAddressInputItem, GeographicalRouteInputItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace MapLocationRoutes {
    export const GetAddress = ApiRoute.Define({
        URL: `address`,
        Kind: RequestKind.Post,
        BodyType: GeographicalAddressInputItem,
        PagingAllowed: true,
        ResultType: string
    });

    export const GetDistance = ApiRoute.Define({
        URL: `distance`,
        Kind: RequestKind.Post,
        ResultType: number,
        BodyType: GeographicalRouteInputItem
    });
}
